export default __webpack_public_path__ + "static/media/graph.47c2d5ea.svg";